module.exports = __webpack_public_path__ + "static/media/ehealth_pro_acc_p2_2.60495ba8.png";